var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.66634H13.3333C13.7015 6.66634 14 6.96481 14 7.33301V13.9997C14 14.3679 13.7015 14.6663 13.3333 14.6663H2.66667C2.29848 14.6663 2 14.3679 2 13.9997V7.33301C2 6.96481 2.29848 6.66634 2.66667 6.66634H3.33333V5.99967C3.33333 3.42235 5.42267 1.33301 8 1.33301C10.5773 1.33301 12.6667 3.42235 12.6667 5.99967V6.66634ZM11.3333 6.66634V5.99967C11.3333 4.15873 9.84093 2.66634 8 2.66634C6.15905 2.66634 4.66667 4.15873 4.66667 5.99967V6.66634H11.3333ZM7.33333 9.33301V11.9997H8.66667V9.33301H7.33333Z",
    fill: "#4F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLocked);
export default __webpack_public_path__ + "static/media/lock-locked.7fbb23a7194e42da8c343342c9b578ac.svg";
export { ForwardRef as ReactComponent };